import React from 'react'

import FlashCard from '@components/Content/FlashCard/FlashCard'

import { wpFlashCardsType } from '@contracts/wp/wpFlashCard'

import * as styles from './FlashCardGrid.module.scss'

interface Props {
	data: wpFlashCardsType
	type: 'full' | 'light'
}

const FlashCardGrid: React.FunctionComponent<Props> = (props) => {
	const flashCards = props.data.map((flashCard) => {
		return <FlashCard key={flashCard.uri} data={flashCard} type={props.type} />
	})

	return (
		<ul className={styles.grid}>
			{flashCards.map((flashCard, i) => {
				return <li key={`flashcard-${i}`}>{flashCard}</li>
			})}
		</ul>
	)
}

FlashCardGrid.defaultProps = {
	type: 'full',
}

export default FlashCardGrid
